import { Component, OnInit, ChangeDetectionStrategy, Inject, forwardRef } from '@angular/core';

@Component({
  selector: 'app-limit-dialog',
  templateUrl: './limit-dialog.component.html',
  styleUrls: ['./limit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LimitDialogComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit() {
  }
}
